export const initCopyUrl = () => {
  const printBtns = document.getElementsByClassName('print-page');
  if (!printBtns) return;

  Array.prototype.slice.call(printBtns).forEach((printBtn) => {
    printBtn.addEventListener('click', () => {
      window.print();
    });
  });

  const copyBtns = document.getElementsByClassName('copy-url');
  if (!copyBtns) return;

  Array.prototype.slice.call(copyBtns).forEach((copyBtn) => {
    copyBtn.addEventListener('click', () => {
      const inputc = document.body.appendChild(document.createElement('input'));
      inputc.value = window.location.href;
      inputc.focus();
      inputc.select();
      document.execCommand('copy');
      inputc.parentNode.removeChild(inputc);

      copyBtn.classList.add('copied');

      const temp = setInterval(() => {
        copyBtn.classList.remove('copied');
        clearInterval(temp);
      }, 1200);
    });
  });
};

export default 'initCopyUrl';
